import http from "@/services/http";
import {ref} from 'vue';
import {useAuth} from "@/services/auth.js";

export const vendas = () => {
  const auth = useAuth();
  // Mensagem de erro da última tentativa de venda (ex.: "Estoque
  // insuficiente: ..."), pra tela mostrar o motivo de verdade em vez de
  // um texto genérico. createItem() continua retornando só true/false-ish
  // (o objeto da venda ou `false`), então nada que já lê o retorno quebra.
  const lastErrorMessage = ref(null);

  async function createItem(venda) {
    const dados = {
      customer_id: venda.cliete === 'avulso' ? null : venda.cliete.id,
      items: venda.lista.map(item => ({
        type: item.type ?? 'product',
        id: item.id,
        quant: item.quant,
        price: item.price,
        buy: item.buy,
      })),
      total: venda.total,
      payment_method_id: venda.payment_method_id,
    };
    try {
      const {data} = await http.post('/sales', dados, auth.getBearer());
      lastErrorMessage.value = null;
      // Retorna o registro da venda (id, date, ...) para o recibo de
      // impressão; continua "truthy" então o `if (await ...)` existente
      // segue funcionando sem mudanças.
      return data.data;
    } catch (error) {
      lastErrorMessage.value = error?.response?.data?.message ?? null;
      console.log(error?.response?.data);
      return false;
    }
  }

  return {createItem, lastErrorMessage}
}
